module.exports = __webpack_public_path__ + "static/Eveve-fee9663b5df5e57abc4b2236c6e313d7.svg";